"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const widgetsToolRegistry = {
  renderWidget: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./render-widget").then(({ RenderWidgetToolView }) => ({
        default: RenderWidgetToolView,
      }))
    ),
  },
  displayWidget: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./display-widget").then(({ DisplayWidgetToolView }) => ({
        default: DisplayWidgetToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
